// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3WWnR","buttons":"Footer_buttons__pGA5v"};